import { request } from "@/utils/request";
export function sendVeriCode(params) {
    return request({
        url: `/api/v1/ctMember/member/sendVeriCode`,
        method: "get",
        params: {
            ...params
        },
    });
}
